import { Component } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ProductV2Service } from "src/app/core/services/product-v2.service";
import { V3ServicesService } from "src/app/core/services/v3-services.service";
import { CustomVissionComponent } from "../../ui-elements/custom-vission/custom-vission.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
@Component({
  selector: "app-vissions",
  templateUrl: "./vissions.component.html",
  styleUrls: ["./vissions.component.scss"],
})
export class VissionsComponent {
  serviceForm: FormGroup;
  hasChanges = false;
  isSubmitted = false;
 public Editor = ClassicEditor;
  isUpdating = false;
  deletedService = [];
  constructor(
    private fb: FormBuilder,
    private apiv2: ProductV2Service,
    private toastr: ToastrService,
    private api: V3ServicesService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.resetForm();
    this.getHeaderServices();
  }

  resetForm() {
    this.serviceForm = this.fb.group({
      services: this.fb.array([]),
    });
  }

  getHeaderServices() {
    this.api.getVissionService().subscribe((result: any) => {
      console.log(result);

      this.setData(result);
    });
  }

  setData(result) {
    this.serviceForm = this.fb.group({
      services: new FormArray([]),
    });
    result.forEach((ao) => {
      (this.serviceForm.get("services") as FormArray).push(
        this.fb.group({
          id: [ao.id],
          heading: [ao.heading, [Validators.required]],
          description: [ao.description, [Validators.required]],
          is_updated: [false],
          is_new: [false],
        })
      );
    });
  }

  service(): FormArray {
    return this.serviceForm.get("services") as FormArray;
  }

  newservice(): FormGroup {
    return this.fb.group({
      heading: ["", [Validators.required]],
      description: ["", [Validators.required]],
      is_updated: [false],
      is_new: [true],
    });
  }

  addservice() {
    this.service().push(this.newservice());
  }

  removeservice(i: number) {
    this.isSubmitted = false;
    this.serviceForm.value.services[i].is_deleted = true;
    if (this.serviceForm.value.services[i].hasOwnProperty("id"))
      this.deletedService.push(this.serviceForm.value.services[i]);
    this.service().removeAt(i);
  }

  dataChanged(i) {
    let ae = this.serviceForm.value.services[i];
    if (ae.is_new) {
      delete ae.is_updated;
    } else {
      ae.is_updated = true;
      delete ae.is_new;
    }
  }

  showSortModal(data, label) {
    let data_card: any = {
      list: data,
      label: label,
    };
    const modalRef = this.modalService.open(CustomVissionComponent, {
      size: "md",
      scrollable: true,
      windowClass: "modal-big-lg",
      keyboard: false,
      backdrop: "static",
    });
    modalRef.componentInstance.sortData = data_card;
    modalRef.result.then((result) => {
      if (result) this.getHeaderServices();
    });
  }

  onSubmit(form) {
    if (form.valid) {
      this.isUpdating = true;
      this.deletedService.forEach((ae) => {
        delete ae.is_updated;
        delete ae.is_new;
        form.value.services.push(ae);
      });
      this.api.setVissionService(form.value.services).subscribe(
        () => {
          this.toastr.success("Content Updated Successfully!");
          this.getHeaderServices();
          this.hasChanges = false;
          this.isUpdating = false;
        },
        () => {
          this.isUpdating = false;
        }
      );
    }
  }
}
